import React, { Component } from 'react';
import Moment from 'moment';
import 'moment/locale/pt-br';
import { Link } from 'react-router';

export default class BlogWrapper extends Component {


    render() {
        return (
            <div className={'col-md-' + this.props.width} style={{ minHeight: '456px' }}>
                <Link className="blogWrapper" to={'/blog/post/' + this.props.id}>
                    <article className="post-wrapper">
                        <div className="thumb-wrapper waves-effect waves-block waves-light">
                            <img src={this.props.imgLink} className="img-responsive" alt="" />
                            <div className="post-date">
                                {Moment(this.props.dataPublicacao).format('d')}<span>{Moment(this.props.dataPublicacao).format('MMM')}</span>
                            </div>
                        </div>
                        <div className="blog-content" style={{ minHeight: '305px' }}>
                            <div className="hover-overlay light-blue"></div>
                            <header className="entry-header-wrapper sticky">
                                <div className="entry-header">
                                    <h2 className="entry-title">{this.props.titulo}</h2>
                                    <div className="entry-meta">
                                        <ul className="list-inline">
                                            <li>
                                                {this.props.categoria}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </header>
                            <div className="entry-content">
                                <p>{this.props.resumo}</p>
                            </div>
                        </div>
                    </article>
                </Link>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/BlogWrapper.js